<template>
	<div class="topbar">
		<div class="nav w">
			<div class="mod_barMsg">
				<div>
					<span class="iconfont">&#xe849;</span>
					<span class="margin6">{{ weather.city || LocationPCity }}</span>
					<span>|</span>
					<span class="margin6">{{ getDay }} {{ gettime }} {{ week }}</span>
					<span v-if="weather.city">|</span>
					<span v-if="weather.city" class="margin6">{{ weather.wea }} {{ weather.tem_night }}°C ~ {{ weather.tem_day }}°C</span>
				</div>
			</div>
			<ul>
				<!-- <li v-if="Object.keys(this.$store.state.user.userInfo).length === 0">
					<el-button type="text" @click="login">登录</el-button>
					<span class="sep">|</span>
					<el-button type="text" @click="register">注册</el-button>
				</li>
				<li v-else>
					欢迎
					<el-popover placement="top" width="180" v-model="visible" trigger="hover">
						<p>确定退出登录吗？</p>
						<div style="text-align: right; margin: 10px 0 0">
							<el-button size="mini" type="text" @click="visible = false">取消</el-button>
							<el-button type="primary" size="mini" @click="logout">确定</el-button>
						</div>
						<el-button type="text" slot="reference" style="color: #42a5f5">
							{{ this.$store.state.user.userInfo.userName }}
						</el-button>
					</el-popover>
				</li> -->

				<li id="shopCart" :class="this.$store.state.shoppingCart.cartNum > 0 ? 'shopCart-full' : 'shopCart'" v-if="Object.keys(this.$store.state.user.userInfo).length !== 0">
					<router-link to="/shopCar">
						<i class="el-icon-shopping-cart-full"></i> 我的购物车
						<span class="num">({{ this.$store.state.shoppingCart.cartNum }})</span>
					</router-link>
				</li>
				<template>
					<li v-if="this.$store.state.user.userInfo.shopStatus == 1">
						<router-link to="/SellerCenter">工作台</router-link>
					</li>
					<li v-if="Object.keys(this.$store.state.user.userInfo).length !== 0">
						<router-link to="/buyerCenter">个人中心</router-link>
					</li>
				</template>
				<li v-if="Object.keys(this.$store.state.user.userInfo).length != 0">
					<div style="position: relative">
						<i class="el-icon-bell" style="font-size: 20px; line-height: 50px; cursor: pointer" @mouseover="showmsgdigog = true">
							<span
								v-show="sysListConfigTable.tableData.length > 0 || waitListConfigTable.tableData.length > 0"
								style="width: 7px; height: 7px; background-color: red; border-radius: 50%; position: absolute; top: 20px; right: 0; z-index: 99"
							></span>
						</i>
					</div>
				</li>
			</ul>
		</div>
		<div
			@mouseleave="showmsgdigog = false"
			v-show="showmsgdigog"
			style="
				width: 800px;
				padding: 15px;
				overflow: auto;
				height: 685px;
				position: absolute;
				top: 60px;
				right: 300px;
				border-radius: 5px;
				background: #ffffff;
				border: 1px solid #f0f0f0;
				box-shadow: 0 0 15px 0 rgba(0, 64, 134, 0.24);
				z-index: 19961121;
			"
		>
			<i class="el-icon-caret-top" style="position: absolute; top: -20px; right: 30%; font-size: 30px; z-index: 199999; color: rgb(255, 255, 255)"></i>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="系统消息" name="first">
					<tableTotal
						v-if="sysListConfigTable.tableData.length > 0"
						:index-show="sysListConfigTable.indexShow"
						:config-data="sysListConfigTable.configData"
						:table-data="sysListConfigTable.tableData"
						:loading="sysListConfigTable.loading"
						@handleClick="syshandleClick"
						@selectChange="syshandleSelectionChangeFn"
						@handleSelectionChange="syshandleSelectionChangeFn"
					>
					</tableTotal>
					<el-empty v-if="sysListConfigTable.tableData.length <= 0" description="暂无系统消息"></el-empty>

					<div class="flex-be m-t-20" v-if="sysListConfigTable.tableData.length > 0">
						<!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
						<div style="width: 50px; height: 20px"></div>
						<el-pagination
							@current-change="sysmsg"
							@size-change="syshandleSizeChange"
							:current-page.sync="sysListConfigTable.current"
							style="float: none"
							layout="total, sizes, prev, pager, next, jumper"
							background
							:page-sizes="[10, 15, 20]"
							:page-size="sysListConfigTable.pageSize"
							:total="sysListConfigTable.total"
						></el-pagination>
					</div>
				</el-tab-pane>

				<el-tab-pane label="待办消息" name="second">
					<tableTotal
						v-if="waitListConfigTable.tableData.length > 0"
						:index-show="waitListConfigTable.indexShow"
						:config-data="waitListConfigTable.configData"
						:table-data="waitListConfigTable.tableData"
						:loading="waitListConfigTable.loading"
						@handleClick="waithandleClick"
						@selectChange="waithandleSelectionChangeFn"
						@handleSelectionChange="waithandleSelectionChangeFn"
					>
					</tableTotal>
					<el-empty v-if="waitListConfigTable.tableData.length <= 0" description="暂无待办消息"></el-empty>

					<div class="flex-be m-t-20" v-if="waitListConfigTable.tableData.length > 0">
						<!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
						<div style="width: 50px; height: 20px"></div>
						<el-pagination
							@current-change="waitmsg"
							@size-change="waithandleSizeChange"
							:current-page.sync="waitListConfigTable.current"
							style="float: none; !important"
							layout="total, sizes, prev, pager, next, jumper"
							background
							:page-sizes="[10, 15, 20]"
							:page-size="waitListConfigTable.pageSize"
							:total="waitListConfigTable.total"
						></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import Cookie from '@/utils/cookie'
import tableTotal from '@/components/TableTotal/TableTotal'

export default {
	components: { tableTotal },
	data() {
		return {
			LocationPCity: '北京市',
			getDay: '',
			gettime: '',
			week: '',
			weather: '',
			clearTime: '',
			visible: false,
			activeName: 'first',
			showmsgdigog: false,
			// 配置表格
			sysListConfigTable: {
				loading: false,
				indexShow: false,
				configData: [
					// {
					// 	type: 'selection'
					// },
					{
						value: 'content',
						label: '内容',
						align: ' left'
					},
					{
						value: 'ctime',
						label: '创建时间',
						width: '100',
						align: 'left'
					},

					{
						label: '操作',
						width: '220',
						fixed: 'right',
						type: 'handleList',
						align: 'left',
						buttonList: [
							{
								label: '标记已读',
								event: 'onread',
								show: false,
								showText: true,
								text: '确定删除?',
								showCondition: (row) => {
									// 评论状态 0:未读 1:已读
									return row.status === 0
								}
							},
							{
								label: '删除',
								event: 'delete',
								show: true,
								showText: true,
								btnStyle: 'color:red;',
								text: '确定删除?'
							}
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			waitListConfigTable: {
				loading: false,
				indexShow: false,
				configData: [
					// {
					// 	type: 'selection'
					// },
					{
						value: 'content',
						label: '内容',
						align: ' left'
					},
					{
						value: 'ctime',
						label: '创建时间',
						width: '100',
						align: 'left'
					},

					{
						label: '操作',
						width: '200',
						fixed: 'right',
						type: 'handleList',
						buttonList: [
							{
								label: '查看',
								event: 'seedata',
								show: true,
								showText: true
							}
							// {
							//   label: '删除', event: 'delete', show: true, showText: true,
							//   text: '确定删除?',
							// },
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			}
		}
	},
	mounted() {
		this.getTime()
		this.getDateTime()
		this.weatherGet()
		this.city()

		var that = this
		setTimeout(function () {
			if (Object.keys(that.$store.state.user.userInfo).length != 0) {
				that.sysmsg()
				that.waitmsg()
			}
		}, 1000)
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event, this.activeName)
			this.activeName = tab.name
			if (this.activeName == 'first') {
				this.sysmsg()
			} else {
				this.waitmsg()
			}
		},
		sysmsg() {
			this.sysListConfigTable.loading = true

			this.$http
				.get(
					this.$const.common.userNoticePage,
					{
						page: this.sysListConfigTable.current,
						pageSize: this.sysListConfigTable.pageSize,
						type: 0
					},
					true
				)
				.then((res) => {
					if (res.code == '200') {
						this.sysListConfigTable.tableData = res.data.records
						this.sysListConfigTable.total = res.data.total
						this.sysListConfigTable.loading = false
					}
				})
				.catch((error) => {
					console.log(error, 'error')
				})
		},
		// 表格多选 全选
		syshandleSelectionChangeFn(data) {
			// this.tableSelect = data;
		},
		syshandleSizeChange(val) {
			this.sysListConfigTable.pageSize = val
			this.sysmsg()
		},
		syshandleClick(event, data, text) {
			switch (event) {
				case 'onread':
					this.$http
						.post(this.$const.common.userNoticeRead, [data.noticeId], true)
						.then((res) => {
							if (res.code == '200') {
								this.sysmsg()
							}
						})
						.catch((error) => {
							console.log(error, 'error')
						})
					break
				case 'delete':
					// this.$confirm(text, "提示", {
					// 	confirmButtonText: "确定",
					// 	cancelButtonText: "取消",
					// 	type: "warning",
					// })
					// 	.then(() => {
					this.$http
						.post(this.$const.common.userNoticeDelete, [data.noticeId], true)
						.then((res) => {
							if (res.code == '200') {
								this.sysmsg()
							}
						})
						.catch((error) => {
							console.log(error, 'error')
						})
					// });
					break
			}
		},
		waitmsg() {
			this.waitListConfigTable.loading = true

			this.$http
				.get(
					this.$const.common.userNoticePage,
					{
						page: this.waitListConfigTable.current,
						pageSize: this.waitListConfigTable.pageSize,
						type: 1
					},
					true
				)
				.then((res) => {
					if (res.code == '200') {
						this.waitListConfigTable.tableData = res.data.records
						this.waitListConfigTable.total = res.data.total
						this.waitListConfigTable.loading = false
					}
				})
				.catch((error) => {
					console.log(error, 'error')
				})
		},
		// 表格多选 全选
		waithandleSelectionChangeFn(data) {
			// this.tableSelect = data;
		},
		waithandleSizeChange(val) {
			this.waitListConfigTable.pageSize = val
			this.waitmsg()
		},
		waithandleClick(event, data, text) {
			switch (event) {
				case 'seedata':
					console.log(data.content.substr(0, 2), data.content.substring(data.content.length - 19))
					this.$http
						.post(this.$const.common.userNoticeDelete, [data.noticeId], true)
						.then((res) => {
							if (res.code == '200') {
								this.sysmsg()
							}
						})
						.catch((error) => {
							console.log(error, 'error')
						})

					if (data.content.substr(0, 2) == '买家') {
						this.$router.push({ name: 'SellerCenter', query: { type: 'TransactionList', orderNo: data.content.substring(data.content.length - 19) } })
					} else {
						this.$router.push({ name: 'buyerCenter', query: { type: 'buyerCenter', orderNo: data.content.substring(data.content.length - 19) } })
					}

					break
				case 'delete':
					this.$confirm(text, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						let p = {
							collectId: data.id
						}
						// await this.collectDeleteFn(p);
					})
					break
			}
		},
		loginStaus() {
			if (this.$cookie.get('PIE_MALL_Token')) {
			} else {
				this.$http
					.get(this.$const.common.getAuthorizeCode, '', true)
					.then((res) => {
						if (res.code == '200') {
							// location.href='https://www.cpeos.org.cn/personal/login?url='+window.location.href+'?tags=login';
							this.$http
								.form(this.$const.common.cpeosLogin, { authorizeCode: res.data.authorizeCode })
								.then((res) => {
									Cookie.set('PIE_MALL_Token', res.data.accessToken)
									Cookie.set('CPEOS_Token', res.data.cpeosToken)
									this.$store.dispatch('user/getUserINFO', {})
									this.$store.dispatch('shoppingCart/getCartINFO', {})
								})
								.catch((error) => {
									console.log(error, 'error')
								})
						}
					})
					.catch((error) => {
						console.log(error, 'error')
					})
			}
		},
		login() {
			// this.$router.push({ path: `/login?redirect=${this.$route.path}` });

			// location.href='https://www.cpeos.org.cn/personal/login/business?url='+window.location.href;
			location.href = window.dataManage.tianhuiLoginUrl

			// this.$http.get(this.$const.common.getAuthorizeCode, "", true).then((res) => {
			// 	if(res.code=='10021'){
			// 		location.href='https://www.cpeos.org.cn/personal/login?url='+window.location.href;
			// 	}
			// }).catch((error) => {
			// 	console.log(error, 'error')
			// });
		},
		register() {
			// location.href='https://www.cpeos.org.cn/personal/register/business?url='+window.location.href;
			location.href = window.dataManage.tianhuiRegisterUrl + '?url=' + window.location.href
		},
		logout() {
			this.$store.dispatch('user/loginOut', {})
			// this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` });
		},
		city() {
			const geolocation = new BMap.Geolocation()
			var _this = this
			geolocation.getCurrentPosition(
				function getinfo(position) {
					let city = position.address.city //获取城市信息
					let province = position.address.province //获取省份信息
					_this.LocationPCity = city
					// console.log("LocationPCity:", _this.LocationPCity, position)
				},
				function (e) {
					_this.LocationPCity = '北京市'
				},
				{ provider: 'baidu' }
			)
			this.weatherGet()
		},
		weatherGet() {
			this.$http
				.get(this.$const.const_config.account.weather, '', true)
				.then((res) => {
					this.weather = res
				})
				.catch((error) => {
					console.log(error, 'error')
				})
		},
		getTime() {
			var _this = this
			this.clearTime = setInterval(function () {
				_this.getDateTime()
			}, 1000)
			this.getWeekDay(new Date())
		},
		getDateTime() {
			let yy = new Date().getFullYear()
			let mm = new Date().getMonth() + 1
			let dd = new Date().getDate()
			let hh = new Date().getHours()
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
			this.getDay = yy + '年' + mm + '月' + dd + '日'
			this.gettime = hh + ':' + mf + ':' + ss
		},
		getWeekDay(date) {
			var week
			if (date.getDay() == 0) this.week = '周日'
			if (date.getDay() == 1) this.week = '周一'
			if (date.getDay() == 2) this.week = '周二'
			if (date.getDay() == 3) this.week = '周三'
			if (date.getDay() == 4) this.week = '周四'
			if (date.getDay() == 5) this.week = '周五'
			if (date.getDay() == 6) this.week = '周六'
			return week
		}
	},
	destroyed() {
		clearTimeout(this.clearTime) // 清除
	}
}
</script>

<style lang="scss" >
/* 顶部导航栏CSS */
.topbar {
	height: 50px;
	line-height: 50px;
	background-color: #151d32;
}

.topbar .nav {
	display: flex;
	margin: 0 auto;
	color: #cccccc;
}

.topbar .nav ul {
	flex: 1;
}

.nav li {
	float: right;
	// height: 50px;
	color: #b0b0b0;
	font-size: 14px;
	text-align: center;
	// line-height: 50px;
	margin-left: 20px;
}

.topbar .nav .sep {
	color: #b0b0b0;
	font-size: 12px;
	margin: 0 5px;
}

// .topbar .nav li .el-button {
// 	color: #b0b0b0;
// }

// .topbar .nav .el-button:hover {
// 	color: #fff;
// }

.topbar .nav li a {
	color: #b0b0b0;
}

// .topbar .nav a:hover {
// 	color: #fff;
// }

.topbar .nav .shopCart {
	width: 120px;
}

.topbar .nav .shopCart:hover {
	background: #2a344f;
}

.topbar .nav .shopCart:hover a {
	color: #eb4090;
}

.topbar .nav .shopCart-full {
	width: 136px;
	background: #eb4090;
	cursor: pointer;
	padding: 0px 7px;
}

.topbar .nav .shopCart-full a {
	color: white;
}

.margin6 {
	margin: 0 6px;
	font-size: 14px;
}

.topbar .el-table__header {
	line-height: 21px;
}
</style>
